import { MARK_ITEM } from '@doltech/ui/lib/figma/BlankEditor/type';
import { ELEMENT_HIGHLIGHT } from '@doltech/ui/lib/figma/DolEditor/elements/highlight/defaults';
import { COUNT_ITEM } from '@doltech/ui/lib/figma/DolEditor/elements/sentences-count/renderElement';
import { isEmpty } from 'lodash';
import { types as t } from 'mobx-state-tree';

import { Paragraph } from '../../paragraph.store';
import { AbstractPassage } from '../abstract-passage.store';

const SYMBOL_SEPARATOR = `$_$`;

export const RegularPassage = AbstractPassage.named('RegularPassage')
  .props({
    paragraph: t.optional(t.maybeNull(Paragraph), { content: '' }),
  })
  .views((self) => ({
    get totalParagraphs() {
      return 1;
    },
    getPassage() {
      const editorObj = [
        {
          type: 'heading-one',
          children: [{ text: self.title ?? '' }],
        },
      ];
      if (self.subTitle) {
        editorObj.push({
          type: 'heading-two',
          children: [{ text: self.subTitle }],
        });
      }
      editorObj.push({
        type: 'paragraph',
        children: [
          {
            text: self.paragraph?.content ?? '',
          },
        ],
      });
      return editorObj;
    },
    getSelectedPassage() {
      const editorObj = [];
      editorObj.push({
        type: 'paragraph',
        children: [
          {
            text: self.paragraph?.content,
          },
        ],
      });
      return editorObj;
    },
    getPassageParagraph({ explanation, isLocateExplanation }) {
      const { content } = self.paragraph;
      const contentWithlocatedPassage = isLocateExplanation
        ? content.replace(explanation.selectedPassage, () => {
            return `${SYMBOL_SEPARATOR}${explanation.locatedPassage}${SYMBOL_SEPARATOR}`;
          })
        : content;
      return contentWithlocatedPassage
        .split(/\n/g)
        .filter((txt) => !isEmpty(txt))
        .map((paragraphText) => {
          if (paragraphText.includes(SYMBOL_SEPARATOR)) {
            const nodes = [];
            const splitParagraphs = paragraphText
              .split(SYMBOL_SEPARATOR)
              .filter((txt) => txt !== SYMBOL_SEPARATOR);
            nodes.push({ type: MARK_ITEM, children: [{ text: '' }] });
            splitParagraphs.forEach((item) => {
              try {
                const childrens = JSON.parse(item).map((n) => n.children);
                childrens.forEach((child) => {
                  child.forEach((node) => {
                    const isEmptyTextNode =
                      Object.keys(node).length === 1 && (node?.text || '').trim().length === 0;
                    if (node?.type === ELEMENT_HIGHLIGHT) {
                      node.children = node.children.filter((n) => n.type !== COUNT_ITEM);
                    }
                    if (node.type !== COUNT_ITEM && !isEmptyTextNode) {
                      nodes.push(node);
                    }
                  });
                });
                return;
                // eslint-disable-next-line no-empty
              } catch (ex) {}
              nodes.push({ text: item });
            });
            return {
              type: 'paragraph',
              children: nodes,
            };
          }
          return {
            type: 'paragraph',
            children: [
              {
                text: paragraphText,
              },
            ],
          };
        });
    },
  }));
